import React, { useContext, useEffect, useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { activity, briefcase, calendar, check, heart, mapPin } from 'react-icons-kit/feather'
import { Link } from 'react-router-dom'
import { io } from 'socket.io-client'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { UserContext } from '../../../utils/context/userContext'
import Requests from '../../../utils/Requests/Index'
import { HeightCalculate } from '../../../utils/helpers'
import { Images } from '../../../utils/Images'

const Index = ({ item }) => {
    const { user, handleRefetch } = useContext(UserContext)
    const userInfo = useSelector((state) => state.user.userData)
    const [sending, setSending] = useState(false)
    const [sent, setSent] = useState(false)
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })

    // Already proposed to / connected with this member?
    useEffect(() => {
        if (!user || !item?._id) return

        const connected = user?.connections?.find(one => one._id === item._id)
            || user?.sentRequests?.indexOf(item._id) > -1
            || user?.pendingRequests?.indexOf(item._id) > -1

        setSent(Boolean(connected))
    }, [user, item]) // eslint-disable-line react-hooks/exhaustive-deps

    const sendRequest = async () => {
        try {
            setSending(true)
            const response = await Requests.Connection.Connect(item._id, header)

            if (response) {
                toast.success(response.message)

                // Notify the receiver without keeping a socket open for every card
                const socket = io(`${process.env.REACT_APP_API_URL}`, { transports: ["websocket", 'polling'] })
                socket.emit("sendProposal", {
                    senderId: userInfo?.userID,
                    name: userInfo?.name,
                    receiverId: item._id
                })
                setTimeout(() => socket.disconnect(), 2000)

                if (response.status) setSent(true)
                handleRefetch()
            }
            setSending(false)
        } catch (error) {
            setSending(false)
            console.log(error)
        }
    }

    const onlineText = typeof item?.isOnline === 'string' && !item.isOnline.includes('null') ? item.isOnline : ''
    const online = onlineText.startsWith('online')
    const photo = item?.images?.[0]?.name || Images.NoImage
    const about = item?.description && item.description !== 'No description added' ? item.description : null

    return (
        <article className="match-card">
            <header className="match-card-head">
                <span className="match-card-photo">
                    <img
                        src={photo}
                        alt={item?.name || 'Match'}
                        loading="lazy"
                        onError={e => { e.currentTarget.src = Images.NoImage }}
                    />
                    {onlineText ? <i className={`match-card-dot ${online ? 'is-on' : ''}`} title={onlineText} /> : null}
                </span>

                <div className="match-card-id">
                    <h6 className="text-capitalize">{item?.name || 'Member'}</h6>
                    <p>@{item?.profileId || '—'}</p>
                    {onlineText ? <span className={`match-card-state ${online ? 'is-on' : ''}`}>{online ? 'Online now' : 'Offline'}</span> : null}
                </div>
            </header>

            <ul className="match-card-facts">
                <li><Icon icon={calendar} size={13} /> {item?.age ? `${item.age} yrs` : '—'}</li>
                <li><Icon icon={activity} size={13} /> {item?.height ? HeightCalculate(item.height) : '—'}</li>
                <li><Icon icon={mapPin} size={13} /> {item?.city || '—'}</li>
            </ul>

            <p className="match-card-role">
                <Icon icon={briefcase} size={13} />
                <span>{item?.professionArea || item?.workingWith || 'Profession not added'}</span>
            </p>

            {about ? <p className="match-card-about">{about}</p> : null}

            <div className="match-card-tags">
                {item?.religion ? <span>{item.religion}</span> : null}
                {item?.materialStatus ? <span>{item.materialStatus}</span> : null}
                {item?.language ? <span>{item.language}</span> : null}
            </div>

            <footer className="match-card-actions">
                <Link to={`/single-profile/${item?._id}`} className="match-card-btn is-ghost">View profile</Link>

                {sent ?
                    <span className="match-card-btn is-sent"><Icon icon={check} size={14} /> Proposal sent</span>
                    :
                    <button
                        type="button"
                        className="match-card-btn is-primary"
                        onClick={sendRequest}
                        disabled={sending}
                    >
                        <Icon icon={heart} size={14} /> {sending ? 'Sending…' : 'Propose now'}
                    </button>
                }
            </footer>
        </article>
    )
}

export default Index
